import { ArticleCategory, ArticleType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { MinimalFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/schemas/MinimalFormItemSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

export const CartFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      items: z.array(
        MinimalFormItemSchema(t)
          // FIXME
          // rules involving multiple form fields must be stated here, otherwise there's a type error in FormItemScheme
          // in Zod 4 (https://github.com/colinhacks/zod/issues/2474) it might be possible
          .refine((data) => !(data.category !== ArticleCategory.DISCOUNT && Number(data.price) < 0), {
            message: t('AMOUNT_MUST_BE_POSITIVE'),
            path: ['price'],
          })
          .refine((data) => !(data.category === ArticleCategory.DISCOUNT && Number(data.price) > 0), {
            message: t('AMOUNT_MUST_BE_NEGATIVE'),
            path: ['price'],
          })
          .refine((data) => !(data.type === ArticleType.SERVICE && Number(data.units) > 1), {
            message: t('MORE_THAN_ONE_UNIT_ERROR'),
            path: ['units'],
          }),
      ),
    })
    .strict();
